import styles from '../styles/header.module.scss';
import { useAuth } from "../../features/authentication/hooks/useAuth";
import { TeamData } from '../../features/users/slices/teamSlice';
import { useGetAllTeams } from '@/features/users/hooks/useGetAllTeams';
import { getItem } from '@/features/authentication/utils/handleLocalStorage';

export const UserAvatar = () => {
  const token = getItem("token");
  const { data: teamsData } = useGetAllTeams({ enabled: !!token });
  const { user, logout } = useAuth();
  const { idarea, picture, firstname, firstlastname, role, username } = user?.data ?? {};
  const team = teamsData?.data?.find((t: TeamData) => t.id === idarea);

  return (
    <div className={`${styles.header__second}`}>
      <div className={`${styles.header__image_user}`}>
        {picture ?
          <img
            src={picture ?? ""}
            alt="Imagen de perfil"
            className={`${styles.header__img_user}`}
            loading="lazy"
          />
          :
          <img className={`${styles.header__img_user}`}
            src={`https://ui-avatars.com/api/?name=${firstname}+${firstlastname}&background=random`}
            alt="ui avatars"
          />
        }
      </div>
      <div className={`${styles.header__name_user}`}>
        <p className={`${styles.header__label_name}`}>{username}</p>
        <p className={`${styles.header__label_job}`}>
          {role}--{team?.areaName}
        </p>
      </div>
      <div className={`${styles.header__logout}`}>
        <button className={`${styles.header__logout_button}`}
          aria-label="logout button" onClick={logout}>
        </button>
      </div>
    </div>
  );
};
